import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AccessDetailEmailComponent } from './access-detail-email.component';
import { PhoneNumberFormatModule } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { ParsedDateTimeModule } from '../../../libs/ui/pipes/parsed-date-time/parsed-date-time.module';

@NgModule({
  declarations: [AccessDetailEmailComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    PhoneNumberFormatModule,
    TranslateModule,
    ParsedDateTimeModule,
  ],
  exports: [AccessDetailEmailComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class AccessDetailEmailModule {}
